export { SESSION_IDLE_TIMEOUT_MS, SESSION_REFRESH_INTERVAL_MS } from 'services/session/SessionCoordinator';

// Compatibility reader for tabs opened before the shared session coordinator.
export const sessionActivityKey = (baseURL: string, userId: number) =>
  `bips:session-activity:${baseURL}:${userId}`;

export const readSessionActivity = (key: string): number | null => {
  try {
    const value = Number(localStorage.getItem(key));
    return Number.isFinite(value) && value > 0 ? value : null;
  } catch {
    return null;
  }
};

export const writeSessionActivity = (key: string, timestamp: number) => {
  try {
    localStorage.setItem(key, String(timestamp));
  } catch {
    // The timer still works within this tab when browser storage is unavailable.
  }
};
